import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21aa40f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "radio-label" }
const _hoisted_4 = { class: "radio-btn-wrapper" }
const _hoisted_5 = { class: "radio-btn" }

import {computed,onMounted,ref} from 'vue';
enum LabelPosition {
    Bottom,
    Top,
}
const btnHoverSize = '1.25lh';
const btnSize = '1lh';
const selectedSize = '0.9lh';

export default /*#__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'RadioButton',
  props: {
    modelValue: {},
    id: {},
    label: {},
    labelPosition: { default: LabelPosition.Bottom },
    hideCheck: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "5d0dee08": (btnHoverSize),
  "71812f02": (btnSize),
  "34ec61d7": (selectedSize),
  "60424e7a": (`--${_ctx.id}`),
  "f80282ce": (`${_ctx.hideCheck?'hidden':'unset'}`)
}))


const props = __props;
const emits = __emit;
const assign = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const checkedEl = ref<HTMLElement>();
onMounted(()=>{
    if ((checkedEl.value?.parentElement?.parentElement?.parentElement?.children.item(0) as HTMLInputElement).checked) emits('change', checkedEl.value, props.id);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass([_ctx.$attrs.class, 'flex-col-centered', { reverse: _ctx.labelPosition === LabelPosition.Bottom }, 'radio-btn-cont']),
    for: _ctx.id
  }, [
    _withDirectives(_createElementVNode("input", _mergeProps(_ctx.$attrs, {
      class: "actual",
      type: "radio",
      id: _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((assign).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', checkedEl.value, _ctx.id)))
    }), null, 16, _hoisted_2), [
      [_vModelRadio, assign.value]
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "radio-on",
          ref_key: "checkedEl",
          ref: checkedEl
        }, null, 512)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})